<template>
  <div>
    <Head title="Lista de precios" />
    <h1 class="mb-8 text-3xl font-bold">Lista de precios</h1>
    <div class="flex items-center justify-between mb-6">
      <search v-model="form.search" class="mr-4 w-full max-w-md" @reset="reset" />
      <button class="btn-sky" @click="showDialog">Agregar Lista</button>
    </div>
    
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold">          
          <th class="pb-4 pt-6 px-2">Código</th>
          <th class="pb-4 pt-6 px-2">Descripción</th>
          <th class="pb-4 pt-6 px-2"># Productos</th>
          <th class="pb-4 pt-6 px-2">Habilitado</th>
          <th class="pb-4 pt-6 px-2">Opciones</th>
        </tr>
        <tr v-for="price in prices.data" :key="price.id" class="hover:bg-gray-100 focus-within:bg-gray-100">          
          <td class="border-t px-6 py-4">            
              {{ price.codigo }}
          </td>
          <td class="border-t px-6 py-4">            
              {{ price.descripcion }}            
          </td>
          <td class="border-t px-6 py-4">            
              {{ price.products_count }}            
          </td>
          <td class="border-t px-6 py-4">            
              {{ price.estatus }}            
          </td> 
          <td class="border-t">
            <div class="flex">
              <div class="flex-1 py-4">
                <button class="btn-sky"  @click="goToProducts(price.id)">
                  <!-- <icon name="product" class="text-center"  /> Clase de icono de Font Awesome -->
                  <p>Ver</p>
                </button> 
              </div>
              <Link class="flex-1 items-center px-2 py-4" :href="`/prices/${price.id}/edit`">
                <button class="focus:outline-none text-white bg-green-500 hover:bg-green-800 focus:ring-4 focus:ring-green-300 font-medium rounded text-sm px-5 py-2.5 me-2 mb-2 dark:bg-green-600 dark:hover:bg-green-700 dark:focus:ring-green-900">
                  Editar                        
                </button>              
              </Link>
              <div class="flex-1 py-4">
              <button class="focus:outline-none text-white bg-red-700 hover:bg-red-800 focus:ring-4 focus:ring-red-300 font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2 dark:bg-red-600 dark:hover:bg-red-700 dark:focus:ring-red-900" @click="removeListPrice(price.id)">
                Eliminar                        
              </button> 
            </div>                       
            </div>
          </td>
        </tr>
        <tr v-if="prices.data.length === 0">
          <td class="px-6 py-4 border-t" colspan="14">No se encontraron listas de precios.</td>
        </tr>
      </table>
    </div>
    <pagination class="mt-6" :links="prices.links" />
  </div>
  <div>    
    <DialogInput v-if="showDialogInput" v-model="dialogValue" label="Nombre" :title="'Crear lista de precios'" @close="closeDialog">      
      <form class="w-full max-w-sm py-2" @submit.prevent="store">
        <div>
          <text-input v-model="form.code" class="py-2 w-full" label="Código" />          
          <text-input v-model="form.description" class="py-2 w-full" label="Descripción" />
        </div>
        <div class="flex items-center justify-center px-8 py-4">          
          <loading-button :loading="form.processing" class="btn-sky" type="submit">Crear</loading-button>
        </div>
        <span class="text-sm justify-end">Los productos los podras agregar más adelante</span>
      </form>
    </DialogInput>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Search from '@/Shared/Search'
import DialogInput from '@/Shared/Dialog'
import InputFile from '@/Shared/InputFile'
import TextInput from '@/Shared/TextInput'
import TextareaInput from '@/Shared/TextareaInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import Icon from '@/Shared/Icon'
import Pagination from '@/Shared/Pagination'
import Swal from 'sweetalert2'

export default {
  components: {
    Head,
    Link,
    Search,
    DialogInput,
    LoadingButton,
    SelectInput,
    TextInput,
    TextareaInput,
    InputFile,
    Icon,
    Pagination,
    
  },
  layout: Layout,
  props: {    
    prices: Array,  
    filters: Object,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        code:'',
        description: '',
        search: this.filters.search,
      }),
      dialogValue: '',
      showDialogInput: false, // Nuevo dato para controlar la visibilidad del diálogo
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get('/prices', pickBy(this.form), { preserveState: true })
      }, 150),
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
    goToProducts(priceId) {
      window.location.href = `/prices/${priceId}/products`
    },
    store() {
      // Utilizando async/await para esperar la respuesta del envío de datos
      (async () => {
        try {
          await this.$inertia.post('/prices', this.form)
          // Si la respuesta es exitosa, puedes agregar aquí cualquier lógica adicional
          this.closeDialog();
        } catch (error) {
          console.error('Error al enviar datos:', error)
          // Puedes manejar el error aquí si es necesario
        }
      })()
    },    
    showDialog() {
      this.showDialogInput = true // Mostrar el diálogo al hacer clic en el botón
    },
    closeDialog() {
      this.showDialogInput = false // Cerrar el diálogo cuando se emite el evento 'close'
    },
    removeListPrice(id){
      Swal.fire({
        title:'Remover Lista de Precios',
        text:'¿Está seguro?',
        icon:'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Remover',
      }).then((result)=>{
        if(result.isConfirmed){
          this.$inertia.put(`/prices/${id}/delete`)
        }
      });
    },   
  },
}
</script>
<style>
.route-button {
  background-color: #4CAF50; /* Green */
  border: none;
  color: white;
  padding: 10px 20px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  margin: 4px 2px;
  cursor: pointer;
  border-radius: 8px;
}
</style>